import * as Sentry from "@sentry/react";
import { useMutation } from "@tanstack/react-query";
import { useFetchAccessToken } from "~/api/salesForce/useFetchAccessToken";
import { QueryKeys } from "~/queryKeys";
import { salesforceServiceSingleton } from "~/services/salesForce/salesForce";
import { useLocaleStore } from "~/stores/locale/useLocaleStore";
import { notifyOnce } from "~/utils/toast.utils";
import { CreateHeyLightOrderBody } from "../models/Heylight";

export const useCreateHeyLightOrder = (opportunityId: string) => {
  const { locale } = useLocaleStore();
  const { data } = useFetchAccessToken();

  return useMutation({
    mutationKey: [QueryKeys.useCreateHeyLightOrder],
    mutationFn: (body: CreateHeyLightOrderBody) =>
      salesforceServiceSingleton.createHeyLightOrder(
        data?.accessToken ?? "",
        opportunityId,
        body,
        locale
      ),
    onError: (error: Error) => {
      Sentry.captureException(error);
      if (error.cause !== 401) {
        notifyOnce(
          {
            toastType: "error",
            descriptionId: "heylight.order.error",
          },
          "useCreateHeyLightOrderError"
        );
      }
    },
  });
};
